// Pattern for question mark
const detectQuestionMark = /\?$/;
const newRegrex = /[.,/#$%^&*;:{}=\-_`~()?]/g;

// Function to normalize and check question existence
export function checkQuestionExists(question, chatBotFAQsQuestions) {
  const normalizedQuestion = question
    .toLowerCase()
    .replace(detectQuestionMark, "");

  // First, check the main questions
  for (let item of chatBotFAQsQuestions) {
    const normalizedItemQuestion = item.question
      .toLowerCase()
      .replace(detectQuestionMark, "");
    if (normalizedQuestion === normalizedItemQuestion) {
      return item;
    }
  }

  // If not found, check question variations
  for (let item of chatBotFAQsQuestions) {
    if (item.questionVariations) {
      for (let variation of item.questionVariations) {
        const normalizedVariationTitle = variation.title
          .toLowerCase()
          .replace(detectQuestionMark, "");
        if (normalizedQuestion === normalizedVariationTitle) {
          return item;
        }
      }
    }
  }

  return undefined;
}

// Original Levenshtein distance function
function levenshteinDistance(str1, str2) {
  const srt1Length = str1.length;
  const str2Length = str2.length;
  const distanceMatrix = Array.from(Array(srt1Length + 1), () =>
    Array(str2Length + 1).fill(0)
  );

  for (let i = 0; i <= srt1Length; i++) {
    for (let j = 0; j <= str2Length; j++) {
      if (i === 0) {
        distanceMatrix[i][j] = j;
      } else if (j === 0) {
        distanceMatrix[i][j] = i;
      } else if (str1[i - 1] === str2[j - 1]) {
        distanceMatrix[i][j] = distanceMatrix[i - 1][j - 1];
      } else {
        distanceMatrix[i][j] =
          1 +
          Math.min(
            distanceMatrix[i][j - 1],
            distanceMatrix[i - 1][j],
            distanceMatrix[i - 1][j - 1]
          );
      }
    }
  }

  return distanceMatrix[srt1Length][str2Length];
}

// new function for check question with spelling mismatch and punctuation
export function matchQuestion(questionString, questionsArray) {
  const cleanedQuestion = questionString
    .trim()
    .toLowerCase()
    .replace(newRegrex, "")
    .trim();

  for (let obj of questionsArray) {
    const mainQuestion = obj.question
      .trim()
      .toLowerCase()
      .replace(newRegrex, "")
      .trim();
    const variations = obj.questionVariations.map((variation) =>
      variation.title.trim().toLowerCase().replace(newRegrex, "").trim()
    );

    const mainDistance = levenshteinDistance(cleanedQuestion, mainQuestion);
    const mainSimilarity =
      1 - mainDistance / Math.max(cleanedQuestion.length, mainQuestion.length);

    let foundMatch = false;
    for (let variation of variations) {
      const variationDistance = levenshteinDistance(cleanedQuestion, variation);
      const variationSimilarity =
        1 -
        variationDistance / Math.max(cleanedQuestion.length, variation.length);

      const similarityThreshold = 0.9;

      if (
        mainSimilarity >= similarityThreshold ||
        variationSimilarity >= similarityThreshold
      ) {
        foundMatch = true;
        break;
      }
    }

    if (foundMatch) {
      return obj;
    }
  }

  return undefined;
}
